(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ironline-columbus-sale-2026"] && !Shopify.designMode) return;
  try {
    (() => {
    const banner = document.getElementById('ironline-halloween-sale-2026');
    if (!banner) return;
    const remaining = Date.parse(banner.dataset.ends) - Date.now();
    if (remaining <= 0) { banner.remove(); return; }
    setTimeout(() => banner.remove(), Math.min(remaining, 2147483647));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ironline-cruise-preview"] && !Shopify.designMode) return;
  try {
    class IronlineCruisePreview extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.productId) return;
      const section = this.closest('.shopify-section');
      if (!section) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      section.addEventListener('variant:selected', () => { this.hidden = true; }, { signal });
      section.addEventListener('variant:update', event => {
        if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
        const variant = event.detail.resource;
        const title = (variant?.title || '').toLowerCase();
        const supportedYear = this.dataset.fixedYear === 'true' || /2020|2023/.test(title);
        this.hidden = !variant || !supportedYear || title.includes('asap');
      }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  if (!customElements.get('ironline-cruise-preview')) customElements.define('ironline-cruise-preview', IronlineCruisePreview);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ironline-file-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ironline-file-delivery')) {
    customElements.define('ironline-file-delivery', class extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.productId) return;
        this.controller = new AbortController();
        const section = this.closest('.shopify-section');
        section?.addEventListener('variant:selected', () => this.showProvider('choice'), {signal: this.controller.signal});
        section?.addEventListener('variant:update', event => {
          if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
          const index = Number(this.dataset.providerIndex);
          let provider = this.dataset.provider;
          if (index >= 0) {
            const value = String(event.detail?.resource?.options?.[index] || '');
            provider = /asap/i.test(value) ? 'asap' : /ironline/i.test(value) ? 'ironline' : 'choice';
          }
          this.showProvider(provider);
        }, {signal: this.controller.signal});
      }
      disconnectedCallback() { this.controller?.abort(); }
      showProvider(provider) {
        this.querySelectorAll('[data-file-provider]').forEach(panel => { panel.hidden = panel.dataset.fileProvider !== provider; });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ironline-self-service"] && !Shopify.designMode) return;
  try {
    class IronlineHelp extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.platform = this.querySelector('[data-help-platform]');
      this.year = this.querySelector('[data-help-year]');
      this.provider = this.querySelector('[data-help-provider]');
      this.exhaust = this.querySelector('[data-help-exhaust]');
      const params = new URLSearchParams(location.search);
      for (const [key, input] of [['platform', this.platform], ['provider', this.provider], ['exhaust', this.exhaust]]) {
        const value = params.get(key);
        if (value && Array.from(input.options).some(option => option.value === value)) input.value = value;
      }
      const requestedYear = (params.get('year') || '').replace(/[–—]/g, '-');
      if (Array.from(this.year.options).some(option => option.value === requestedYear)) this.year.value = requestedYear;
      else if (/^20\d{2}$/.test(requestedYear)) {
        const value = Number(requestedYear);
        const match = Array.from(this.year.options).find(option => {
          if (option.dataset.platform !== this.platform.value) return false;
          const range = option.value.split('-').map(Number);
          return value >= range[0] && value <= range[1];
        });
        if (match) this.year.value = match.value;
      }
      this.addEventListener('change', event => {
        if (!event.target.matches('select')) return;
        this.update();
        const url = new URL(location.href);
        for (const [key, input] of [['provider',this.provider],['platform',this.platform],['year',this.year],['exhaust',this.exhaust]]) { if(input.value) url.searchParams.set(key,input.value); else url.searchParams.delete(key); }
        history.replaceState(history.state,'',url);
      }, {signal: this.controller.signal});
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); }
    update() {
      const platform = this.platform.value;
      Array.from(this.year.options).forEach(option => {
        option.hidden = Boolean(option.dataset.platform && option.dataset.platform !== platform);
        option.disabled = option.hidden;
      });
      if (this.year.selectedOptions[0]?.disabled) this.year.value = '';
      const asap = this.provider.querySelector('[value="asap"]');
      asap.disabled = platform === 'cummins';
      asap.hidden = asap.disabled;
      if (platform === 'cummins') this.provider.value = 'ironline';
      const mode = this.dataset.supportMode;
      this.querySelectorAll('[data-help-provider-content]').forEach(node => node.hidden = !this.provider.value);
      this.querySelectorAll('[data-help-truck-control]').forEach(node => node.hidden = mode === 'ezlynk' && !this.provider.value);
      this.querySelectorAll('[data-provider-choice]').forEach(link => { link.hidden = platform === 'cummins' && link.dataset.providerChoice === 'asap'; if(link.dataset.providerChoice === this.provider.value) link.setAttribute('aria-current','true'); else link.removeAttribute('aria-current'); });
      this.querySelectorAll('[data-help-for-provider]').forEach(node => node.hidden = Boolean(this.provider.value && node.dataset.helpForProvider !== this.provider.value));
      this.querySelectorAll('[data-help-for-platform]').forEach(node => node.hidden = node.dataset.helpForPlatform !== platform);
      this.querySelectorAll('[data-help-year-only]').forEach(node => node.hidden = Boolean(this.year.value && !node.dataset.helpYearOnly.split(',').includes(this.year.value)));
      this.querySelectorAll('[data-help-for-exhaust]').forEach(node => node.hidden = Boolean(this.exhaust.value && node.dataset.helpForExhaust !== this.exhaust.value));
      const root = this.closest('.shopify-section') || document;
      const provider = root.querySelector('[name="contact[Calibration provider]"]');
      const year = root.querySelector('[name="contact[Truck year]"]');
      if (provider && this.provider.value) provider.value = this.provider.value === 'asap' ? 'ASAP Calibrations' : 'Ironline Tuning';
      if (year && this.year.value) year.value = this.year.value.replace('-', '–');
      if (this.exhaust.value) this.querySelector('[data-help-exhaust-details]').open = true;
      this.dispatchEvent(new CustomEvent('ironline:help-selection',{bubbles:true,detail:{platform,year:this.year.value,provider:this.provider.value,exhaust:this.exhaust.value}}));
    }
  }
  if (!customElements.get('ironline-help')) customElements.define('ironline-help', IronlineHelp);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ironline-setup-purchase"] && !Shopify.designMode) return;
  try {
    class IronlineSetupPurchase extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.section = this.closest('.shopify-section');
      this.form = this.closest('form');
      this.variant = JSON.parse(this.querySelector('[data-selected-variant]').textContent);
      this.saleConfig = JSON.parse(this.querySelector('[data-sale-config]').textContent);
      this.saleTimer = setTimeout(() => this.sync(), Math.max(0, Math.min(Date.parse(this.saleConfig.ends)-Date.now(),2147483647)));
      this.optionNames = JSON.parse(this.querySelector('[data-setup-options]').textContent);
      this.labels = JSON.parse(this.querySelector('[data-checklist-labels]').textContent);
      this.workLabels = JSON.parse(this.querySelector('[data-work-labels]').textContent);
      this.workPurchase = this.dataset.workPurchase === 'true';
      this.variants = JSON.parse(this.querySelector('[data-work-variants]')?.textContent || '[]');
      const hardwareData = this.querySelector('[data-hardware-addons]');
      this.hardwareAddons = hardwareData ? JSON.parse(hardwareData.textContent) : null;
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency || 'USD'});
      this.deviceLabels = JSON.parse(this.querySelector('[data-device-labels]').textContent);
      this.ownsDevice = false;
      this.reviewed = false;
      this.busy = false;
      this.querySelector('[data-upgrades]')?.removeAttribute('hidden');
      this.bar = this.querySelector('[data-mobile-bar]');
      this.bar.hidden = false;
      this.buttonError = this.querySelector('[data-truck-error-button]');
      this.releaseNote = this.querySelector('[data-release-note]');
      this.addButton = this.form?.querySelector('[name="add"]');
      const buttons = this.form?.querySelector('.product-form-buttons') || this.addButton;
      if (buttons) {
        this.barObserver = new IntersectionObserver(entries => {
          const visible = entries.some(entry => entry.isIntersecting);
          this.bar.toggleAttribute('data-visible', !visible);
        });
        this.barObserver.observe(buttons);
      }
      this.section.addEventListener('variant:selected', () => {this.busy = true;if (this.workPurchase) this.reviewed = false;this.sync();}, {signal});
      this.section.addEventListener('variant:update', event => {
        if (String(event.detail.data.productId) !== this.dataset.productId) return;
        this.variant = event.detail.resource;
        this.busy = false;
        this.sync();
      }, {signal});
      this.section.addEventListener('change', event => {
        if (event.target.matches('[data-kind="cruise"]') && event.target.checked) {
          const physical = this.querySelector('[data-kind="switch"]');
          if (physical) physical.checked = false;
        }
        this.sync();
      }, {signal});
      this.section.addEventListener('input', () => this.sync(), {signal});
      this.section.addEventListener('quantity-selector:update', () => this.sync(), {signal});
      const nativePrice = this.section.querySelector('product-price');
      if (nativePrice) {
        this.primaryPrice = document.createElement('span');
        this.primaryPrice.className = 'ild-setup-primary-price';
        this.primaryPrice.setAttribute('data-setup-primary-price', '');
        this.primaryPrice.setAttribute('aria-live', 'polite');
        this.primaryPrice.hidden = true;
        const priceStyle = getComputedStyle(nativePrice.querySelector('.price') || nativePrice);
        for (const property of ['color','fontFamily','fontSize','fontWeight','fontStyle','letterSpacing','lineHeight','textAlign']) this.primaryPrice.style[property] = priceStyle[property];
        nativePrice.before(this.primaryPrice);
      }
      this.managedCart = this.dataset.managedCart === 'true';
      if (this.managedCart) {
        this.section.addEventListener('click', event => {
          const link = event.target.closest('[data-provider-compare]');
          if (!link) return;
          const details = this.section.querySelector('#' + CSS.escape(link.getAttribute('aria-controls')));
          if (!details) return;
          event.preventDefault();
          details.open = true;
          details.querySelector('summary')?.focus({preventScroll:true});
          details.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
        }, {signal});
      }
      this.disableManagedAppOffers();
      this.optionsObserver = new MutationObserver(records => {
        const appChanged = records.some(record => {
          const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
          if (target?.closest('#key_options_block,[data-essential-upsell-id="cd9a6b69-9ca4-4b25-ba87-80485d82468a"]')) return true;
          return Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(node => node.nodeType === 1 && (node.id === 'key_options_block' || node.querySelector('#key_options_block,[data-essential-upsell-id="cd9a6b69-9ca4-4b25-ba87-80485d82468a"]') || node.matches('[data-essential-upsell-id="cd9a6b69-9ca4-4b25-ba87-80485d82468a"]')));
        });
        if (appChanged) {this.disableManagedAppOffers();this.sync();}
      });
      this.optionsObserver.observe(this.section, {childList:true,subtree:true,characterData:true});
      this.querySelector('[data-mobile-action]').addEventListener('click', () => {
        if (this.managedCart) {
          const button = this.form.querySelector('[name="add"]');
          if (!this.busy && !button?.disabled && this.form.reportValidity()) button?.click();
          return;
        }
        if (this.workPurchase && !this.reviewed) {
          const review = this.querySelector('[data-package-checklist]');
          review.open = true;
          review.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});
          review.querySelector('summary')?.focus({preventScroll:true});
          this.reviewed = true;
          this.sync();
          return;
        }
        if (!this.reviewed) {
          const picker = this.section.querySelector('variant-picker');
          picker?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
          picker?.querySelector('input:checked,select')?.focus({preventScroll:true});
          this.reviewed = true;
          this.sync();
          return;
        }
        const button = this.form.querySelector('[name="add"]');
        if (!this.busy && !button?.disabled && this.form.reportValidity()) button?.click();
      }, {signal});
      this.intersection = new IntersectionObserver(entries => {
        if (entries.some(entry=>entry.isIntersecting)) {this.reviewed = true;this.sync();}
      }, {threshold:.8});
      this.intersection.observe(this.form.querySelector('[name="add"]'));
      this.sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.saleTimer);
      this.primaryPrice?.remove();
      this.optionsObserver?.disconnect();
      this.intersection?.disconnect();
      this.barObserver?.disconnect();
      this.fieldError?.remove();
    }
    disableManagedAppOffers() {
      if (!this.managedCart) return;
      this.section.querySelectorAll('#key_options_block input, #key_options_block select, [data-essential-upsell-id="cd9a6b69-9ca4-4b25-ba87-80485d82468a"] input').forEach(input => {
        input.disabled = true;
        if (input.type === 'checkbox') input.checked = false;
      });
    }
    syncHardwareAddons() {
      if (!this.hardwareAddons || !this.form) return;
      const packageRange = this.dataset.productTitle.match(/^(\d{4})[^\d]+(\d{4})/);
      const firstYear = Number(packageRange?.[1]);
      const lastYear = Number(packageRange?.[2]);
      const exhaustIndex = this.optionNames.findIndex(name => /exhaust/i.test(String(name)));
      const exhaust = String(this.variant?.options?.[exhaustIndex] || '');
      const diameter = exhaust.match(/^(?:Full\s+)?([45])["”]/i)?.[1];
      const muffler = this.hardwareAddons.mufflers?.find(variant => variant.title === diameter + '-inch');
      const matchingPlugs = (this.hardwareAddons.plugs || []).filter(variant => {
        const range = String(variant.title).match(/^(\d{4})[^\d]+(\d{4})$/);
        return range && firstYear <= Number(range[2]) && lastYear >= Number(range[1]);
      });
      const fitment = this.querySelector('[data-plugs-fitment]');
      const needsChoice = matchingPlugs.length > 1;
      fitment?.closest('[data-plugs-fitment-choice]')?.toggleAttribute('hidden', !needsChoice);
      if (fitment && !this.plugFitmentReady) {
        fitment.replaceChildren(new Option(this.hardwareAddons.labels.kitPlaceholder, ''), ...matchingPlugs.map(variant => new Option(variant.title, String(variant.id))));
        fitment.addEventListener('change', () => {
          const input = this.querySelector('[data-kind="plugs"]');
          if (input) input.checked = Boolean(fitment.value);
          this.sync();
        }, {signal:this.controller.signal});
        this.plugFitmentReady = true;
      }
      const plugs = needsChoice ? matchingPlugs.find(variant => String(variant.id) === fitment?.value) : matchingPlugs[0];
      for (const [kind, variant] of [['muffler', muffler], ['plugs', plugs]]) {
        const input = this.querySelector('[data-kind="' + kind + '"]');
        if (!input) continue;
        const available = Boolean(variant?.available);
        input.disabled = !available || this.busy;
        input.dataset.variantId = available ? String(variant.id) : '';
        input.dataset.price = available ? String(variant.price) : '0';
        input.dataset.variantTitle = available ? variant.title : '';
        if (!available) input.checked = false;
        const price = this.querySelector('[data-hardware-price="' + kind + '"]');
        if (price && variant) price.textContent = '+' + this.money.format(Number(variant.price) / 100);
        const match = this.querySelector('[data-hardware-match="' + kind + '"]');
        if (match) {
          const labels = this.hardwareAddons.labels;
          if (needsChoice && !plugs && kind === 'plugs') match.textContent = labels.chooseKit;
          else if (!available) match.textContent = labels.unavailable;
          else {
            const message = kind === 'muffler' ? labels.matchedMuffler : labels.matchedPlugs;
            match.textContent = message.replace('[value]', variant.title);
            if (kind === 'plugs' && firstYear >= 2020 && lastYear <= 2022) match.textContent += ' ' + labels.plugsExclusions;
          }
        }
        const review = this.querySelector('[data-checklist-' + kind + ']');
        if (review) review.textContent = input.checked && available ? variant.title : this.hardwareAddons.labels.notAdded;
      }
    }
    syncDeviceChoice() {
      const choice = this.querySelector('[data-device-selection][value="owned"]');
      this.ownsDevice = Boolean(choice?.checked);
      choice?.setCustomValidity(this.ownsDevice ? this.deviceLabels.preview : '');
      this.querySelector('[data-device-help]')?.toggleAttribute('hidden', !this.ownsDevice);
      this.querySelector('[data-device-preview]')?.toggleAttribute('hidden', !this.ownsDevice);
      this.section.querySelectorAll('[data-device-inclusion]').forEach(node => {
        node.textContent = this.ownsDevice ? this.deviceLabels.owned : this.deviceLabels.included;
      });
      const benefits = this.section.querySelector('.ild-simple-benefits li');
      if (benefits) benefits.textContent = this.ownsDevice ? this.deviceLabels.ownedBenefits : this.deviceLabels.includedBenefits;
    }
    selectedAddons() {
      return Array.from(this.querySelectorAll('[data-setup-addon]:checked:not(:disabled)'));
    }
    cartItems(formData) {
      const addons = this.selectedAddons();
      if (!addons.length && !this.managedCart) return null;
      const quantity = Number(formData.get('quantity')) || 1;
      const properties = {};
      for (const [key,value] of formData.entries()) {
        if (key.startsWith('properties[') && key.endsWith(']') && typeof value === 'string' && value.trim()) properties[key.slice(11,-1)] = value.trim();
      }
      if (this.managedCart) {
        const vin = this.querySelector('[data-setup-vin]')?.value.trim().toUpperCase();
        if (vin) properties.VIN = vin;
        else delete properties.VIN;
        properties['SOTF option'] = addons.some(input => input.dataset.kind === 'switch') ? '5 Position SOTF Switch' : 'Not added';
        if (addons.some(input => input.dataset.kind === 'cruise')) properties['Cruise-control SOTF'] = 'Added';
      }
      const localInstallation = addons.some(input => input.dataset.kind === 'local-install');
      if (localInstallation) properties['Local installation'] = this.querySelector('ironline-local-install')?.dataset.location || 'New Braunfels';
      const addonProperties = {'Setup': this.dataset.productTitle};
      const groupSetup = this.workPurchase || localInstallation;
      if (groupSetup) {
        const group = globalThis.crypto?.randomUUID?.() || Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
        properties._ild_setup_group = group;
        properties._ild_setup_role = 'setup';
        addonProperties._ild_setup_group = group;
        addonProperties._ild_setup_role = 'addon';
      }
      if (properties['Truck Year']) addonProperties['Truck Year'] = properties['Truck Year'];
      if (properties['VIN']) addonProperties['VIN'] = properties['VIN'];
      if (localInstallation && properties['Preferred installation date']) addonProperties['Preferred installation date'] = properties['Preferred installation date'];
      for (const input of addons) {
        if (input.dataset.kind === 'muffler') properties['Muffler'] = input.dataset.variantTitle;
        if (input.dataset.kind === 'plugs') properties['Harness Plug Kit'] = input.dataset.variantTitle;
      }
      return [{id:Number(formData.get('id')),quantity,properties}, ...addons.map(input=>({id:Number(input.dataset.variantId),quantity,properties:{...addonProperties,...(groupSetup ? {_ild_setup_kind:input.dataset.kind} : {})}}))];
    }
    sync() {
      const checklist = this.querySelector('[data-package-checklist]');
      checklist.hidden = !this.variant;
      checklist.setAttribute('aria-busy', String(this.busy));
      if (!this.variant || !this.form) {
        if (this.primaryPrice) this.primaryPrice.hidden = true;
        this.querySelector('[data-mobile-action]').disabled = true;
        return;
      }
      this.syncDeviceChoice();
      this.syncHardwareAddons();
      this.querySelector('ironline-local-install')?.sync?.();
      const sotf = (this.variant.options || []).some(value=>String(value).includes('SOTF'));
      const switchInput = this.querySelector('[data-kind="switch"]');
      if (switchInput && !this.managedCart) {
        switchInput.disabled = !sotf || this.busy;
        if (!sotf) switchInput.checked = false;
        switchInput.closest('label').hidden = !sotf;
      }
      const support = this.querySelector('[data-kind="support"]');
      const supportNote = this.querySelector('[data-support-note]');
      if (supportNote) supportNote.hidden = Boolean(support?.checked);
      const egrIncluded = this.dataset.cummins !== 'true' || (this.variant.options || []).some(value=>String(value).startsWith('Add EGR'));
      this.section.querySelectorAll('[data-setup-egr]').forEach(node => {
        node.textContent = egrIncluded ? this.dataset.egrIncluded : this.dataset.egrExcluded;
      });
      const optionValue = pattern => {
        const index = this.optionNames.findIndex(name => pattern.test(String(name)));
        return index < 0 ? '' : String(this.variant.options?.[index] || '');
      };
      const provider = optionValue(/provider/i) || this.querySelector('[data-checklist-provider]').textContent;
      const cruiseInput = this.querySelector('[data-kind="cruise"]');
      if (cruiseInput) {
        const eligible = provider === 'Ironline Diesel';
        cruiseInput.disabled = !eligible || this.busy;
        cruiseInput.closest('label').hidden = !eligible;
        if (!eligible) cruiseInput.checked = false;
      }
      if (switchInput && this.managedCart) {
        if (cruiseInput?.checked && !cruiseInput.disabled) switchInput.checked = false;
        switchInput.disabled = this.busy || Boolean(cruiseInput?.checked && !cruiseInput.disabled);
        switchInput.closest('label').classList.toggle('ild-option-unavailable', switchInput.disabled);
      }
      const access = optionValue(/support|access/i) || (support?.checked ? this.labels.fullSupport : this.labels.fourWeeks);
      const fullSupport = /full|lifetime/i.test(access);
      this.querySelector('[data-checklist-exhaust]').textContent = optionValue(/exhaust/i);
      this.querySelector('[data-checklist-provider]').textContent = provider;
      if (this.releaseNote) {
        this.releaseNote.textContent = /asap/i.test(provider)
          ? this.labels.asapTiming : this.labels.ironlineTiming;
      }
      this.querySelector('[data-checklist-support]').textContent = fullSupport ? this.labels.fullSupport : this.labels.fourWeeks;
      this.querySelector('[data-checklist-support-detail]').textContent = fullSupport ? this.labels.fullSupportDetail : this.labels.fourWeeksDetail;
      if (this.workPurchase) {
        const isAsap = /asap/i.test(provider);
        const supportKey = (isAsap ? 'asap' : 'ironline') + (fullSupport ? 'FullSupport' : 'FourWeeks');
        this.querySelector('[data-checklist-support-detail]').textContent = this.workLabels[supportKey];
        const supportSummary = this.section.querySelector('[data-work-support-summary]');
        if (supportSummary) supportSummary.textContent = this.workLabels[supportKey];
        this.querySelector('[data-checklist-connection]').textContent = this.workLabels[isAsap ? 'asapConnection' : 'ironlineConnection'];
        this.releaseNote.textContent = this.workLabels.processing;
        for (const providerName of ['ironline','asap']) {
          const matching = this.variants.find(candidate => candidate.options[0] === this.variant.options[0] && candidate.options[2] === this.variant.options[2] && /asap/i.test(candidate.options[1]) === (providerName === 'asap'));
          const price = this.section.querySelector('[data-work-provider-price="' + providerName + '"]');
          if (price && matching) price.textContent = this.money.format(matching.price / 100);
        }
      }
      let switchDescription = this.labels.switchCheckCart;
      let appSwitch = null;
      if (this.dataset.cummins === 'true' || this.managedCart) {
        switchDescription = switchInput?.checked ? this.labels.switchSelected : this.labels.switchNotSelected;
      } else {
        const switchGroups = Array.from(this.section.querySelectorAll('#key_options_block [role="group"]')).filter(group => /\bSOTF\b[\s\S]*switch|switch[\s\S]*\bSOTF\b/i.test(group.textContent));
        appSwitch = switchGroups.length === 1 ? switchGroups[0].querySelector('input[type="checkbox"]') : null;
        if (appSwitch) {
          switchDescription = appSwitch.checked ? this.labels.switchSelected : this.labels.switchNotSelected;
          const switchCents = Number(this.dataset.switchPrice);
          const label = appSwitch.closest('label');
          if (label && this.dataset.switchPrice && Number.isFinite(switchCents)) {
            const amount = this.money.format(switchCents / 100);
            const walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
            let node;
            while ((node = walker.nextNode())) {
              const fixed = node.nodeValue.replace(/\[\s*\+\s*[^\]]+\]/g, '[+' + amount + ']');
              if (fixed !== node.nodeValue) node.nodeValue = fixed;
            }
          }
        }
      }
      this.querySelector('[data-checklist-switch]').textContent = switchDescription;
      const includedTcm = /asap/i.test(provider) && /2020/.test(this.dataset.productTitle);
      const showTcm = includedTcm || (/asap/i.test(provider) && /2023/.test(this.dataset.productTitle));
      this.querySelector('[data-checklist-tcm-row]').hidden = !showTcm;
      this.querySelector('[data-checklist-tcm]').textContent = includedTcm ? this.labels.tcmIncluded : (/\+\s*TCM/i.test(access) ? this.labels.tcmSelected : this.labels.tcmNotSelected);
      if (this.workPurchase) {
        this.querySelector('[data-checklist-tcm-row]').hidden = false;
        this.querySelector('[data-checklist-tcm]').textContent = this.workLabels.tcmAvailability;
      }
      const beforeSaleCents = Number(this.variant.price);
      const saleNow = Date.now();
      const saleActive = saleNow >= Date.parse(this.saleConfig.starts) && saleNow < Date.parse(this.saleConfig.ends);
      const setupPercent = saleActive && this.saleConfig.ironline.includes(String(this.variant.id)) ? Number(this.saleConfig.setupPercent) : 0;
      const addonPercent = saleActive && this.dataset.powerstroke === 'true' ? Number(this.saleConfig.addonPercent) : 0;
      let cents = Math.round(beforeSaleCents * (1-setupPercent));
      let totalKnown = true;
      let saleApplied = setupPercent > 0;
      for (const input of this.selectedAddons()) {
        const addonCents = Number(input.dataset.price);
        const effectiveAddonPercent = input.dataset.kind === 'local-install' ? 0 : addonPercent;
        cents += Math.round(addonCents * (1-effectiveAddonPercent));
        if (effectiveAddonPercent > 0 && addonCents > 0) saleApplied = true;
      }
      const cruiseOffer = this.section.querySelector('[data-essential-upsell-id="cd9a6b69-9ca4-4b25-ba87-80485d82468a"]');
      const cruiseSelected = cruiseOffer?.querySelector('input[type="checkbox"]:checked');
      if (!this.managedCart && cruiseSelected && provider === 'Ironline Diesel') {
        const cruisePrice = Number(cruiseOffer.querySelector('[data-regular-price-value]')?.dataset.regularPriceValue);
        if (Number.isFinite(cruisePrice)) {
          cents += Math.round(cruisePrice * 100 * (1-addonPercent));
          if (addonPercent > 0 && cruisePrice > 0) saleApplied = true;
        }
        else totalKnown = false;
      }
      if (this.dataset.cummins !== 'true' && appSwitch?.checked) {
        const switchCents = Number(this.dataset.switchPrice);
        if (this.dataset.switchPrice && Number.isFinite(switchCents)) {
          cents += Math.round(switchCents * (1-addonPercent));
          if (addonPercent > 0 && switchCents > 0) saleApplied = true;
        }
        else totalKnown = false;
      }
      const totalLabel = saleApplied ? this.labels.saleSubtotal : this.labels.subtotal;
      this.querySelector('[data-total-label]').textContent = totalLabel;
      this.querySelector('[data-mobile-total-label]').textContent = totalLabel;
      this.querySelector('[data-total-note]').textContent = saleApplied ? this.labels.subtotalNote : this.labels.regularNote;
      this.querySelector('[data-sale-line]')?.toggleAttribute('hidden', !setupPercent);
      if (this.primaryPrice) {
        const unitPrice = totalKnown ? this.money.format(cents/100) : this.labels.totalCheckCart;
        if (this.primaryPrice.textContent !== unitPrice) this.primaryPrice.textContent = unitPrice;
        this.primaryPrice.hidden = false;
      }
      const quantity = Math.max(1, Number(this.form.querySelector('[name="quantity"]')?.value) || 1);
      this.querySelector('ironline-local-install')?.updateTotals?.(cents, quantity);
      const formatted = totalKnown ? this.money.format(cents*quantity/100) : this.labels.totalCheckCart;
      this.querySelector('[data-setup-total]').textContent = formatted;
      this.querySelector('[data-mobile-total]').textContent = formatted;
      const action = this.querySelector('[data-mobile-action]');
      action.textContent = this.managedCart || this.reviewed ? this.dataset.add : (this.workPurchase ? this.workLabels.reviewAction : this.dataset.review);
      if (this.addButton) this.addButton.disabled = this.busy || this.getAttribute('aria-busy') === 'true' || !this.variant.available;
      action.disabled = this.busy || this.getAttribute('aria-busy') === 'true' || !this.variant.available;
    }
  }
  if (!customElements.get('ironline-setup-purchase')) customElements.define('ironline-setup-purchase', IronlineSetupPurchase);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('invalid', event => {
    const step = event.target.closest?.('[data-ild-required-year]');
    if (!step) return;
    event.preventDefault();
    step.setAttribute('aria-invalid', 'true');
    const error = step.querySelector('.ild-year-error');
    if (error) error.hidden = false;
    if (step.dataset.focusing) return;
    step.dataset.focusing = 'true';
    queueMicrotask(() => {
      delete step.dataset.focusing;
      step.scrollIntoView({block:'center', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      step.querySelector('input,select')?.focus({preventScroll:true});
    });
  }, true);
  document.addEventListener('change', event => {
    const step = event.target.closest?.('[data-ild-required-year]');
    if (!step || !(step.querySelector('input:checked') || step.querySelector('select')?.value)) return;
    step.removeAttribute('aria-invalid');
    const error = step.querySelector('.ild-year-error');
    if (error) error.hidden = true;
  });

  function ironlineUpdateHelpLinks(picker, variant) {
    if (!picker) return;
    const routingInputs = picker.querySelectorAll('[data-ild-routing]');
    if (!variant) {
      routingInputs.forEach(input => {input.value = ''; input.disabled = true;});
      return;
    }
    let names;
    try { names = JSON.parse(picker.dataset.ildOptionNames || '[]'); } catch { return; }
    const option = pattern => {
      const index = names.findIndex(name => pattern.test(String(name)));
      return index < 0 ? '' : String(variant.options?.[index] || '');
    };
    const title = picker.dataset.ildProductTitle || '';
    const provider = /asap/i.test(option(/provider/i) || title) ? 'asap' : 'ironline';
    const yearValue = option(/^(truck )?year$/i) || title.match(/\b20\d{2}\s*[–-]\s*20\d{2}\b/)?.[0] || '';
    const year = yearValue.replace(/–/g,'-').replace(/\s/g,'').replace(/^2023\+$/,'2023-2026');
    const supportedYears = ['2011-2016','2017-2019','2020-2022','2023-2026','2013-2018','2019-2021'];
    const exhaustValue = option(/exhaust/i);
    const exhaust = /race/i.test(exhaustValue) ? 'race' : /5/.test(exhaustValue) ? '5' : /4/.test(exhaustValue) ? '4' : '';
    const params = new URLSearchParams({provider,platform:picker.dataset.ildPlatform || 'powerstroke'});
    if (supportedYears.includes(year)) params.set('year',year);
    if (exhaust) params.set('exhaust',exhaust);
    routingInputs.forEach(input => {
      input.value = params.get(input.dataset.ildRouting) || '';
      input.disabled = !input.value;
    });
    const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (preview) params.set('preview_theme_id',preview);
    document.querySelectorAll('[data-ild-help-product]').forEach(link => {
      if (link.dataset.ildHelpProduct !== picker.dataset.productId) return;
      link.href = '/pages/contact?' + params.toString() + '#' + link.dataset.ildHelpAnchor;
    });
  }
  document.addEventListener('variant:update', event => {
    const productId = String(event.detail?.data?.productId || '');
    const picker = Array.from(document.querySelectorAll('variant-picker[data-ild-option-names]')).find(node => node.dataset.productId === productId);
    ironlineUpdateHelpLinks(picker,event.detail?.resource);
  });
  document.querySelectorAll('variant-picker[data-ild-option-names]').forEach(picker => {
    const data = picker.querySelector('script[type="application/json"]');
    if (!data) return;
    try { ironlineUpdateHelpLinks(picker,JSON.parse(data.textContent)); } catch { return; }
  });
  } catch(e) { console.error(e); }
})();

})();
